import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "block pt-6" }
const _hoisted_3 = { class: "columns is-centered is-mobile" }
const _hoisted_4 = { class: "column is-two-thirds" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "colums is-centered is-two-thirds" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column is-10 is-offset-1" }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "has-text-centered has-text-primary is-size-5 p-5",
      style: {"font-family":"Calibri"}
    }, " Nos hemos aliado estratégicamente con marcas destacadas en sus respectivas especialidades, con el objetivo de mejorar la eficiencia en la producción, reducir los costos operativos y elevar la calidad de los productos para beneficio de nuestros clientes. ")
  ])
], -1)
const _hoisted_6 = { class: "hero has-background-blue pt-6 pb-6" }
const _hoisted_7 = { class: "hero-body" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"columns is-centered is-mobile\"><div class=\"column is-two-thirds\"><p class=\"has-text-white has-text-centered is-size-6 pt-4 pb-6\" style=\"font-family:Calibri;font-weight:bold;\"> Valoramos la durabilidad en las relaciones. Creemos en la confianza, la lealtad y el compromiso como pilares clave. Nuestra filosofía se refleja en cada proyecto, marcando la diferencia en el mercado y más allá. </p></div></div><div class=\"is-mobile level\"><div class=\"level-item\"><button class=\"button is-hoverable has-background-yellow has-text-white is-normal\" style=\"font-family:Calibri;font-weight:bold;border:none;width:15rem;height:3rem;\"> CONTACTA A UN ASESOR </button></div></div>", 2)

import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import RepresentadasComponent from "@/components/RepresentadasComponent.vue";
import { useWindowSize } from "vue-window-size";


export default /*#__PURE__*/_defineComponent({
  __name: 'RepresentadasView',
  setup(__props) {

const { width } = useWindowSize();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ContactBar),
      _createVNode(NavigationBar),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", {
              class: _normalizeClass(["has-text-centered has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
              style: {"font-family":"Calibri","font-weight":"bold"}
            }, " REPRESENTAMOS MARCAS SEGURAS, EFICIENTES Y DURABLES ", 2)
          ])
        ]),
        _hoisted_5
      ])
    ]),
    _createVNode(RepresentadasComponent),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h1", {
            class: _normalizeClass(["has-text-centered has-text-white", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
            style: {"font-family":"Calibri","font-weight":"bold"}
          }, " PONTE EN CONTACTO CON NOSOTROS ", 2),
          _hoisted_9
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})